import { Controller } from "@hotwired/stimulus"

import 'swiper/scss';
import 'swiper/scss/navigation';


export default class extends Controller {

  async connect() {
    const { default: Swiper } = await import('swiper');
    const { Navigation } = await import('swiper/modules');

    this.swiper = new Swiper(this.element.querySelector('.swiper'), {
      direction: 'horizontal',
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      modules: [Navigation],
    });
  }
}
